const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://uongbismartcity-api.cgis.asia/",
        media_url: "https://uongbismartcity-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "qhuongbi",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/qhuongbi/wms/",
  },
  production: {
      api: "https://uongbismartcity-api.cgis.asia/",
      media_url: "https://uongbismartcity-api.cgis.asia/",
      domainAdminSide: "https://admin.uongbismartcity.cgis.asia",
      domainUserSide: "https://uongbismartcity.cgis.asia",
      domainName: "uongbismartcity.cgis.asia",
      workSpace: "qhuongbi",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/qhuongbi/wms/",
  },
};

module.exports = apiEnvironment[env];
